import throttle from 'lodash.throttle';
import { useCallback, useEffect, useMemo } from 'react';
import { Model } from 'survey-react-ui';

type UpdateSurvey = (survey: Model, complete: boolean) => Promise<void>;

const DEBOUNCE_MS = 10_000;

const useDebouncedSurveyUpdate = (updateSurvey: UpdateSurvey) => {
  const throttledUpdate = useMemo(
    () =>
      throttle(
        (survey: Model, complete: boolean) => {
          void updateSurvey(survey, complete);
        },
        DEBOUNCE_MS,
        { leading: false, trailing: true }
      ),
    [updateSurvey]
  );

  useEffect(() => () => throttledUpdate.cancel(), [throttledUpdate]);

  return useCallback(
    (survey: Model, complete: boolean, forceUpload = false): Promise<void> => {
      if (forceUpload) {
        throttledUpdate.cancel();

        return updateSurvey(survey, complete);
      }

      throttledUpdate(survey, complete);

      return Promise.resolve();
    },
    [throttledUpdate, updateSurvey]
  );
};

export { useDebouncedSurveyUpdate };
